// extracted by mini-css-extract-plugin
export default {"slideArrowRight":"RightArrow_slideArrowRight__4PJTj"};